module.exports = __webpack_public_path__ + "static/media/majorA2.c8fd4c1.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorA2.wav
// module id = /QCr
// module chunks = 0